import {postAction} from "@/eiuov-utils/axios/api";

const loginAction = (params) => postAction("/reception/member/login", params)
const registerAction = (params) => postAction("/reception/member/register", params)

export {
	loginAction,
	registerAction
}
